// hooks/useInvoices.ts
import { Invoice } from "../types/invoiceForm";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { addItem, clearItems, copyItem, deleteItem, editItem } from "../features/invoiceSlice";

export function useInvoices() {
  const invoices = useSelector((state: RootState) => state.invoices); // Get invoices from Redux stat
  const dispatch = useDispatch();

  const addInvoice = (invoice: Invoice) => {
    dispatch(addItem(invoice));
  };

  const editInvoice = (invoice: Invoice) => {
    dispatch(editItem (invoice));
  };

  const removeInvoice = (id: number) => {
    if(id){
      dispatch(deleteItem({id}));
    }    
  };

  const copyInvoice = (id: number, invoice: Invoice) => {   
    dispatch(copyItem({id: id, data: invoice as Invoice}));
  }

  const clearInvoices = () => {    
    dispatch(clearItems(invoices));
  };

  return {
    invoices,
    addInvoice,
    editInvoice,
    removeInvoice,
    clearInvoices,
    copyInvoice
  };
}
